'use client';
import { jsx } from 'react/jsx-runtime';
import { BasicResponsiveImage } from '../../responsive-image/basic-responsive-image.js';
import { ProgressiveImage } from '../../progressive-image/progressive-image.component.js';
import { FluidImage } from '../../fluid-image/fluid-image.component.js';

function _define_property(e, r, t) {
    return r in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: true,
        configurable: true,
        writable: true
    }) : e[r] = t, e;
}
function _object_spread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {}, o = Object.keys(t);
        "function" == typeof Object.getOwnPropertySymbols && (o = o.concat(Object.getOwnPropertySymbols(t).filter(function(e) {
            return Object.getOwnPropertyDescriptor(t, e).enumerable;
        }))), o.forEach(function(r) {
            _define_property(e, r, t[r]);
        });
    }
    return e;
}
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        t.push.apply(t, o);
    }
    return t;
}
function _object_spread_props(e, r) {
    return r = null != r ? r : {}, Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : ownKeys(Object(r)).forEach(function(t) {
        Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
    }), e;
}
const Img = (n)=>'responsive' === n.variant ? jsx(BasicResponsiveImage, _object_spread_props(_object_spread({}, n), {
        variant: void 0
    })) : 'progressive' === n.variant ? jsx(ProgressiveImage, _object_spread_props(_object_spread({}, n), {
        variant: void 0
    })) : jsx(FluidImage, _object_spread_props(_object_spread({}, n), {
        variant: void 0
    }));
Img.displayName = 'Img';

export { Img };
